module.exports = __webpack_public_path__ + "img/qrcode-teacher.45b93a96.jpg";